import { FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnCancel, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { MyChartMedicineDetailAliases } from '../../codegen';
import { FragmentNames } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';

@Controller({ fragment: FragmentNames.MY_CHART_MEDICINE_DETAIL })
export default class MyChartMedicineDetailController extends BaseController {

  @Inject(MyChartMedicineDetailAliases.FORM_MEDICINES)
    medicinesFormApi!: FormAPI;

  @OnMount(MyChartMedicineDetailAliases.FORM_MEDICINES)
  onFormMount(event: MountEvent): void {
    const medicinesFormApi = event.target as FormAPI;
    const nrSequence = this.getHistoryRouteParam<Value>('nrSequence');
    medicinesFormApi.setRecord({});
    HttpService.get(APPLICATION_ENDPOINTS.GET_MC_MEDICINE_DETAIL, { nrSequence: nrSequence, patientId: UserContext.patientId })
      .then(response => response.body as Record<string, Value>)
      .then(data => {
        medicinesFormApi.setData(data);
      });
  }

  @OnCancel(MyChartMedicineDetailAliases.FORM_MEDICINES)
  onClickCancelButton(): void {
    this.medicinesFormApi.setDisabled(true);
    this.medicinesFormApi.setEditing(false);
  }

}